(function() {
    'use strict';

    angular.module("page")
        .controller('PageListController', PageListController);

    PageListController.$inject = ['$state', 'pageDataSrvc', 'pageSrvc', 'pageMessagesConst', 'notificationSrvc', 'lodashService', 'datatableDefaultPageSizeValueConst', 'checkSearchSrvc', 'pagePermissionsConst', 'redirectOutsideSrvc', 'filterQuerySrvc'];

    function PageListController($state, pageDataSrvc, pageSrvc, pageMessagesConst, notificationSrvc, lodashService, datatableDefaultPageSizeValueConst, checkSearchSrvc, pagePermissionsConst, redirectOutsideSrvc, filterQuerySrvc) {
        var self = this;

        self.loading = true;

        self.pageOpts = {
            count: undefined,
            page: 1,
            pageSize: datatableDefaultPageSizeValueConst
        };

        self.pageRows = [];
        self.pageCols = [{
            title: 'Adres strony',
            value: 'url',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Tytuł',
            value: 'title_seo',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Typ',
            value: 'type',
            type: 'text',
            searchable: true,
            orderable: true
        }, {
            title: 'Menu',
            value: 'menu',
            type: 'text',
            searchable: true,
            orderable: true
        }];

        self.logsInfo = [{
            title: 'Data dodania',
            value: 'date_added'
        }, {
            title: 'Data modyfikacji',
            value: 'date_modified'
        }, {
            title: 'Edytowano przez',
            value: 'last_modified_by'
        }];

        self.modelPermissions = pagePermissionsConst;
        self.searchQuery = {
            url: null,
            title_seo: null,
            type: null,
            menu: null,
            ordering: null
        };

        self.onCreate = onCreate;
        self.onEdit = onEdit;
        self.onDelete = onDelete;
        self.onReorder = onReorder;

        self.pageChange = pageChange;
        self.onSearchQueryChange = onSearchQueryChange;

        self.extraActions = [{
            class: 'btn btn-xs',
            iconClass: 'flag flag-pl',
            onClick: redirectPublicPl,
            isDisabled: isRedirectPublicDisabledPl,
            title: 'Sklep Polski'
        }, {
            class: 'btn btn-xs',
            iconClass: 'flag flag-de',
            onClick: redirectPublicDe,
            isDisabled: isRedirectPublicDisabledDe,
            title: 'Sklep Niemiecki'
        }];

        activate();

        function activate() {
            self.pageOpts = filterQuerySrvc.initializePageOpts(self.pageOpts);
            self.searchQuery = filterQuerySrvc.initializeSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            getPages();
        }

        function getPages(filterObj) {
            self.loading = true;

            if (!filterObj) {
                filterObj = {
                    page: self.pageOpts.page,
                    page_size: self.pageOpts.pageSize,
                    url: self.searchQuery.url,
                    title_seo: self.searchQuery.title_seo,
                    type: self.searchQuery.type,
                    menu: self.searchQuery.menu,
                    ordering: self.searchQuery.ordering
                };
            }
            return pageDataSrvc.list(filterObj)
                .$promise
                .then(
                    function(response) {
                        self.pageRows = response.results;
                        self.pageOpts.count = response.count;
                        return response;
                    },
                    function(response) {
                        if (response.status === 404 && filterObj.page !== 1) {
                            checkSearchSrvc.recall(filterObj, getPages);
                        }
                    }
                ).finally(
                    function(response) {
                        self.loading = false;
                        return response;
                    }
                );
        }

        function onCreate() {
            $state.go('layout.page.create');
        }

        function onEdit(row) {
            $state.go('layout.page.update', { pk: row.pk });
        }

        function onDelete(row) {
            return pageSrvc.remove(row.title_seo, row.pk, function(response) {
                notificationSrvc.notification("success", pageMessagesConst.delete);
                lodashService.remove(self.machineRows, { pk: row.pk });
                return response;
            });
        }

        function pageChange() {
            filterQuerySrvc.updatePageOpts(self.pageOpts);
            filterQuerySrvc.setLocationParams();
            return getPages();
        }

        function onSearchQueryChange() {
            filterQuerySrvc.updateSearchQuery(self.searchQuery);
            filterQuerySrvc.setLocationParams();
            return getPages();
        }

        function onReorder(row, newPos) {
            return pageDataSrvc.update({
                pk: row.pk
            }, {
                position: newPos
            }).$promise.then(
                function(response) {
                    return response;
                },
                function(response) {
                    notificationSrvc.notification("error", pageMessagesConst.error);
                }
            );
        }

        function redirectPublicPl(neww) {
            redirectOutsideSrvc.go(neww.absolute_public_pl_url);
        }

        function redirectPublicDe(neww) {
            redirectOutsideSrvc.go(neww.absolute_public_de_url);
        }

        function isRedirectPublicDisabledPl(neww) {
            return !neww.absolute_public_pl_url;
        }

        function isRedirectPublicDisabledDe(neww) {
            return !neww.absolute_public_de_url;
        }
    }
})();
